import { useSelector } from 'react-redux';
import { RootState } from '../store';
import { POPUP_BASE_URL } from './constants';

export function getKorUclass(uclass: string): { type: string; label: string } {
  let res = { type: '', label: '' };

  switch (uclass) {
    case 'B':
      res = { type: 'color #FF65BD', label: '대표 관리자' };
      break;
    case 'VP':
      res = { type: 'color #2b8ad1', label: '부원장' };
      break;
    case 'CO':
      res = { type: 'color #2b8ad1', label: '실장' };
      break;
    case 'T':
      res = { type: 'color #2b8ad1', label: '선생님' };
      break;
    case 'ETC':
      res = { type: 'color #2b8ad1', label: '기타' };
      break;
    case 'S':
      res = { type: 'color #2b8ad1', label: '재원생' };
      break;
    case 'SB':
      res = { type: 'color #2b8ad1', label: '휴원생' };
      break;
    case 'SX':
      res = { type: 'color #2b8ad1', label: '퇴원생' };
      break;
    case 'SN':
      res = { type: 'color #2b8ad1', label: '미등록생' };
      break;
  }

  return res;
}

export function getKorUPCheck(upcheck: string, type?: string): string {
  const upcheck_list = ['', '어머니', '아버지', '학생'];
  const upcheck_arr = upcheck.split(',').filter(item => item);
  const res = upcheck_arr.map(item => upcheck_list[Number(item)]).join(', ');
  return res.length > 0 ? res : type === 'account' ? '직접 입력' : '전체 미발송';
}

export function getKeyUPCheck(upcheck: string): ('uphone' | 'ufaphone' | 'umyphone')[] {
  const upcheck_list: ('uphone' | 'ufaphone' | 'umyphone')[] = ['uphone', 'ufaphone', 'umyphone'];
  const upcheck_arr = upcheck.split(',').filter(item => item);
  const res: ('uphone' | 'ufaphone' | 'umyphone')[] = upcheck_arr.map(item => upcheck_list[Number(item) - 1]);
  return res;
}

export function getStudentUYear(res_target: string, target: string) {
  const comparison = res_target == 'id' ? 'name' : 'id';
  const contents = [
    { id: 'e1', name: '초등학교 1학년' },
    { id: 'e2', name: '초등학교 2학년' },
    { id: 'e3', name: '초등학교 3학년' },
    { id: 'e4', name: '초등학교 4학년' },
    { id: 'e5', name: '초등학교 5학년' },
    { id: 'e6', name: '초등학교 6학년' },
    { id: 'm1', name: '중학교 1학년' },
    { id: 'm2', name: '중학교 2학년' },
    { id: 'm3', name: '중학교 3학년' },
    { id: 'h1', name: '고등학교 1학년' },
    { id: 'h2', name: '고등학교 2학년' },
    { id: 'h3', name: '고등학교 3학년' },
    { id: 'p4', name: '4세' },
    { id: 'p5', name: '5세' },
    { id: 'p6', name: '6세' },
    { id: 'p7', name: '7세' },
  ];
  const res: { [key: string]: string } | undefined = contents.find(item => {
    return item[comparison] == target;
  });

  if (res) {
    return res[res_target];
  } else {
    return '';
  }
}

export const student_grade_list = [
  { id: 'e1', name: '초등학교 1학년' },
  { id: 'e2', name: '초등학교 2학년' },
  { id: 'e3', name: '초등학교 3학년' },
  { id: 'e4', name: '초등학교 4학년' },
  { id: 'e5', name: '초등학교 5학년' },
  { id: 'e6', name: '초등학교 6학년' },
  { id: 'm1', name: '중학교 1학년' },
  { id: 'm2', name: '중학교 2학년' },
  { id: 'm3', name: '중학교 3학년' },
  { id: 'h1', name: '고등학교 1학년' },
  { id: 'h2', name: '고등학교 2학년' },
  { id: 'h3', name: '고등학교 3학년' },
  { id: 'etc', name: '기타' },
  { id: 'p4', name: '4세' },
  { id: 'p5', name: '5세' },
  { id: 'p6', name: '6세' },
  { id: 'p7', name: '7세' },
];

export const student_upcheck_list: { id: string; name: string }[] = [
  { id: '1', name: '어머니' },
  { id: '2', name: '아버지' },
  { id: '3', name: '학생' },
  { id: 'all_no', name: '전체 미발송' },
];

export const getUserInfo = () => {
  const user_info = useSelector((state: RootState) => state.UserReducer);
  return user_info;
};

export const sendWithinquiresMail = async (inquries: { [key: string]: string }) => {
  const response = await fetch(`${POPUP_BASE_URL}/homepage/sendemail.php`, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
    },
    body: JSON.stringify({ ...inquries }),
  });
  return await response.json();
};

export const sendWithdrawalMail = async (withdraw_datas: { [key: string]: string | boolean | number }) => {
  const response = await fetch(`${POPUP_BASE_URL}/engtrain/sendwithdrawal`, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ ...withdraw_datas }),
  });
  return await response.json();
};

export const createAccount = async (require_datas: { [key: string]: string | boolean | number }) => {
  const response = await fetch(`${POPUP_BASE_URL}/engtrain/settingadmininfoV2`, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ ...require_datas }),
  });
  return await response.json();
};

export const getUpCheckLength = (upcheck: string) => {
  return upcheck.split(',').length;
};

export const getTargetRepresentative = (upcheck: string) => {
  const representative_target = '';
  const representative_target_phone_key = 'phone';
  return { representative_target, representative_target_phone_key };
};

export const insertLog = async (user: UserDefault, action: string) => {
  if (process.env.NODE_ENV === 'production') {
    const params = {
      service: 'checkbus_v2',
      cid: user.cid,
      uid: user.uid,
      uname: user.uname,
      uloginid: user.uloginid,
      uclass: user.uclass,
      action: action,
    };
    const url = process.env.NODE_ENV === 'production' ? 'https://checkbus.irontrain.co.kr' : 'http://49.236.146.241';
    const response = await fetch(`${url}/irontrain/log/add`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ ...params }),
    });

    const responseJson = await response.json();
  }
};
